import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Location} from '@angular/common';
import {KenticoService} from './services/kentico.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  today = Date.now();
  navMenuMobileActive = false;
  lastOffset = 0;
  currentSlug = '';

  constructor(private router: Router,
              private route: ActivatedRoute,
              private kenticoService: KenticoService,
              private location: Location) {
  }

  toggleMenu(): void {
    this.navMenuMobileActive = !this.navMenuMobileActive;
  }

  clickLink(): void {
    this.navMenuMobileActive = false;
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        let currentRoute = this.route.root;
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
        }
        this.currentSlug = currentRoute.snapshot.data.templateSlug;
      }
    });
    window.addEventListener('scroll', this.updateNavBar, false);
    this.updateNavBar();
    window.addEventListener('scroll', this.updateDownArrow, false);
  }

  updateDownArrow() {
    const downArrow = document.getElementsByClassName('down-arrow')[0];
    if (!downArrow) {
      return;
    }
    const offset = window.pageYOffset || document.documentElement.scrollTop;
    if (offset > 0) {
      downArrow.classList.add('hide');
    } else {
      downArrow.classList.remove('hide');
    }
  }

  updateNavBar() {
    const navBar = document.getElementById('nav-bar');
    const hero = document.getElementById('hero');
    const offset = window.pageYOffset || document.documentElement.scrollTop;
    if (offset > this.lastOffset) {
      // downscroll code
      if (offset > (navBar.clientHeight) && !navBar.classList.contains('locked')) {
        navBar.classList.add('hidden');
      }
    } else {
      // upscroll code
      navBar.classList.remove('hidden');
    }
    this.lastOffset = offset;

    if (offset > 0) {
      navBar.classList.add('hovering');
    } else {
      navBar.classList.remove('hovering');
    }

    if (hero) {
      if (offset > hero.getBoundingClientRect().bottom - navBar.clientHeight) {
        navBar.classList.add('opaque');
      } else {
        navBar.classList.remove('opaque');
      }
    }
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.component.ts